import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-062805b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = { class: "menus-container" };
const _hoisted_3 = { class: "btn btn-quadrado valor-descricao-container shadow-none" };
const _hoisted_4 = { class: "valor" };
const _hoisted_5 = { class: "descricao" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { class: "btn btn-quadrado text-black valor-descricao-container shadow-none" };
const _hoisted_10 = { class: "valor" };
const _hoisted_11 = { class: "descricao" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { key: 2 };
const _hoisted_15 = { id: "lista-doacoes" };
const _hoisted_16 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MobileLikeNavHeader = _resolveComponent("MobileLikeNavHeader");
    const _component_AlertaErroContaCadastrada = _resolveComponent("AlertaErroContaCadastrada");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MobileLikeNavHeader, {
            title: "Doações Recebidas",
            height: "100px",
            "go-back-url": "/restrito#/"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.moneyToReais(_ctx.totalRecebido)), 1)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, [
                            (_ctx.listaDoacoes.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Nenhuma doação recebida"))
                                : _createCommentVNode("", true),
                            (_ctx.listaDoacoes.length === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "1 Doação recebida"))
                                : _createCommentVNode("", true),
                            (_ctx.listaDoacoes.length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.listaDoacoes.length) + " Doações Recebidas", 1))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.moneyToReais(_ctx.totalRecebidoMes)), 1)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_11, [
                            (_ctx.doacoesMes.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Nenhuma doação neste mês"))
                                : _createCommentVNode("", true),
                            (_ctx.doacoesMes.length === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "1 Doação neste mês"))
                                : _createCommentVNode("", true),
                            (_ctx.doacoesMes.length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.doacoesMes.length) + " Doações neste mês", 1))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]),
            _createVNode(_component_AlertaErroContaCadastrada)
        ]),
        _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaDoacoes, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event) => (_ctx.showDetalhesDoacao(item))
                }, _toDisplayString(_ctx.getNomeReduzido(item.nome)) + " - " + _toDisplayString(_ctx.moneyToReais(item.valor_bruto_doacao_raw)), 9, _hoisted_16));
            }), 256))
        ])
    ]));
}
